import { required, email } from 'vuelidate/lib/validators'
import { withParams } from 'vuelidate/lib'
import {
  getYTIdFromUrl,
  getVimeoIdFromUrl,
  getDailymotionIdFromUrl,
  getCodepenIdFromUrl,
  getJsFiddleIdFromUrl
} from '@/services/Utils'

export function exactLength(length) {
  return withParams({type: 'exactLength', length}, value => {
    return !required(value) || String(value).length === length
  })
}

export function enrollment(enrollment_type, enrollment_value) {
  return withParams({type: 'enrollment', enrollment_type, enrollment_value}, value => {
    if (!required(value)) {
      return true
    } else if (email(value) && enrollment_type === 'EMAIL') {
      return (new RegExp('@' + enrollment_value + '$', 'i')).test(value)
    }

    return true
  })
}

export const youtubeUrl = withParams({type: 'youtubeUrl'}, value => {
  return !required(value) || getYTIdFromUrl(value) !== false
})

export const vimeoUrl = withParams({type: 'youtubeUrl'}, value => {
  return !required(value) || getVimeoIdFromUrl(value) !== false
})

export const dailymotionUrl = withParams({type: 'youtubeUrl'}, value => {
  return !required(value) || getDailymotionIdFromUrl(value) !== false
})

export const socialVideoUrl = withParams({type: 'socialVideoUrl'}, value => {
  return !required(value) || youtubeUrl(value) || vimeoUrl(value) || dailymotionUrl(value)
})

export const codeUrl = withParams({type: 'codeUrl'}, value => {
  return !required(value) || getCodepenIdFromUrl(value) || getJsFiddleIdFromUrl(value)
})

export function matchRegexp(pattern, flag) {
  return withParams({type: 'matchRegex', pattern, flag}, value => {
    return !required(value) || (new RegExp(pattern, flag)).test(value)
  })
}



// WEBPACK FOOTER //
// ./src/validators/index.js